'use strict';

function initRefButtons() {
  // button data href
  const buttonsDataHref = document.querySelectorAll('[data-href]');

  if (buttonsDataHref.length) {
    [...buttonsDataHref].forEach((buttonDataHref) => {
      buttonDataHref.addEventListener('click', function (event) {

        const dataRef = this.getAttribute('data-href');

        window.open(dataRef, '_blank');
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  initRefButtons();
});


export { initRefButtons };
